import React, { useEffect, useRef } from "react";
import { animateScroll as scroll } from "react-scroll";
import "./Hero.css";

const Hero = () => {
  const vantaRef = useRef(null); // Ref for Vanta.js

  useEffect(() => {
    let vantaEffect;
  
      const setVanta = () => {
        if (window.VANTA) {
          vantaEffect = window.VANTA.GLOBE({
            el: vantaRef.current, // Attach the Vanta effect to this element
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.0,
            minWidth: 200.0,
            scale: 1.0,
            scaleMobile: 1.0,
            size: 1.6,
            color: 0xbfd4de, // Primary color
            color2: 0xfdfffc, // Secondary color
            backgroundColor: 0x061826, // Background color
          });
        }
      };
  
      setVanta();
  
      // Cleanup Vanta effect on component unmount
      return () => {
        if (vantaEffect) vantaEffect.destroy();
      };
    }, []);
  

    useEffect(() => {
      if (window.anime) {
        window.anime({
          targets: ".animated-title",
          translateY: [-20, 0], // Subtle upward movement
          opacity: [0, 1], // Gradual fade-in
          duration: 3000, // Extend duration for smoother animation
          easing: "easeOutQuad", // Softer easing function
          delay: 500, // Slight delay before the animation starts
        });
      }
    }, []);
    
    const handleScroll = () => {
      const nextSection = document.getElementById("about"); // Ensure this ID exists
      if (nextSection) {
        scroll.scrollTo(nextSection.offsetTop, {
          duration: 100, // Smooth scroll duration
          smooth: "easeInOutCubic", // Smooth easing
        });
      }
    };    

  return (
    <section
      id="hero"
      className="hero"
      ref={vantaRef} // Attach Vanta.js to this element
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div
        className="hero-content"
        style={{
          position: "relative",
          zIndex: 1,
          textAlign: "center", // Center-align text
          color: "white",      // Ensure contrast with the background
          padding: "20px",
        }}
      >
      <h1
        className="animated-title"
        onClick={handleScroll} // Scroll functionality
        role="button" // Semantic for accessibility
        tabIndex="0" // Focusable with keyboard
        style={{
          cursor: "pointer", // Pointer cursor for click indication
        }}
      >
      Measure. Mirror. Multiply Happiness
      <span className="left"></span>
      <span className="right"></span>
      </h1>
      

      </div>
    </section>
  );
};

export default Hero;
